import CONSTANTS from '../../constants';

export function memberships(state = null, action) {
	switch (action.type) {
		case CONSTANTS.ACTIONS.MEMBER.GET.MEMBERSHIPS:
			return action.memberships;
		default:
			return state
	}
}